import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';

export type AuthorizeV2Data = {
	response_type: string; // code固定
	client_id: string; // サービスコード
	scope?: string; // openid,emailが指定されていることがある
	redirect_uri?: string;
	state?: string;
	nonce?: string;
	prompt?: string; // 'none' | 'login'
	gid_dp?: string; // ログイン画面設定を取得するID
	gid_act?: string; //'login' | 'register'
	code_challenge?: string; // tokenエンドポイントリクエストのcode_verifierをcode_challenge_methodで変換した文字列
	code_challenge_method?: string; // plain or S256
	gid_reg_act?: string; // none or child or force_child
};

export const initialAuthorizeV2Data: AuthorizeV2Data = {
	response_type: 'code', // 固定
	client_id: undefined, // サービスコード
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	authorizeV2Data: AuthorizeV2Data;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, authorizeV2Data: AuthorizeV2Data) => {
	const action = {
		action: SaveActionName,
		authorizeV2Data,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.authorizeV2Data = thisAction.authorizeV2Data;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const AuthorizeV2ReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
